import React, { createContext, useContext, useState, ReactNode } from "react";

interface PreviewModeContextType {
  isPreviewMode: boolean;
  previewReturnInfo: {
    courseId: string;
    courseName: string;
  } | null;
  enterPreviewMode: (courseId: string, courseName: string) => void;
  exitPreviewMode: () => void;
}

const PreviewModeContext = createContext<PreviewModeContextType | undefined>(undefined);

interface PreviewModeProviderProps {
  children: ReactNode;
}

export const PreviewModeProvider: React.FC<PreviewModeProviderProps> = ({ children }) => {
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [previewReturnInfo, setPreviewReturnInfo] = useState<{
    courseId: string;
    courseName: string;
  } | null>(null);

  const enterPreviewMode = (courseId: string, courseName: string) => {
    setIsPreviewMode(true);
    setPreviewReturnInfo({ courseId, courseName });
  };

  const exitPreviewMode = () => {
    setIsPreviewMode(false);
    setPreviewReturnInfo(null);
  };

  return (
    <PreviewModeContext.Provider
      value={{
        isPreviewMode,
        previewReturnInfo,
        enterPreviewMode,
        exitPreviewMode,
      }}>
      {children}
    </PreviewModeContext.Provider>
  );
};

export const usePreviewMode = (): PreviewModeContextType => {
  const context = useContext(PreviewModeContext);
  if (context === undefined) {
    throw new Error("usePreviewMode must be used within a PreviewModeProvider");
  }
  return context;
};
